import React, { useState, useRef, useEffect, useLayoutEffect } from 'react';
import ReactDOM from 'react-dom';
import VerticalPoints from '../../elements/icon/assets/vertical_points.svg';
import { Container, IconButton, Menu, MenuItem } from './VerticalButton.styled';

const VerticalButton = ({ options = [], dataTestId }) => {
    const [open, setOpen] = useState(false);
    const [menuPosition, setMenuPosition] = useState({ top: 0, left: 0, width: 0 });
    const containerRef = useRef(null);
    const menuRef = useRef(null);

    useLayoutEffect(() => {
        if (open && containerRef.current) {
            const rect = containerRef.current.getBoundingClientRect();
            setMenuPosition({
                top: rect.bottom + 8 + window.scrollY,
                left: rect.right - 160 + window.scrollX,
                width: rect.width
            });
        }
    }, [open]);

    useEffect(() => {
        if (!open) return;
        const handleClickOutside = (event) => {
            if (
                menuRef.current &&
                !menuRef.current.contains(event.target) &&
                containerRef.current &&
                !containerRef.current.contains(event.target)
            ) {
                setOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [open]);

    const handleOptionClick = (option, e) => {
        if (option.onClick) option.onClick(e);
        setOpen(false);
    };

    return (
        <Container ref={containerRef}>
            <IconButton
                src={VerticalPoints}
                alt="Menu options"
                onClick={() => setOpen((v) => !v)}
                data-testid={dataTestId}
            />
            {open && typeof window !== 'undefined' && ReactDOM.createPortal(
                <Menu
                    ref={menuRef}
                    style={{
                        position: 'absolute',
                        top: menuPosition.top,
                        left: menuPosition.left,
                        minWidth: 160,
                        zIndex: 3000
                    }}
                >
                    {options.map((option, idx) => (
                        <MenuItem key={idx} onClick={(e) => handleOptionClick(option, e)}>
                            {option.title}
                        </MenuItem>
                    ))}
                </Menu>,
                document.body
            )}
        </Container>
    );
};

export default VerticalButton;
